import {
  AUTHENTICATE_SALES_ASSISTED,
  AUTHENTICATE_SALES_ASSISTED_ERROR,
  AUTHENTICATE_SALES_ASSISTED_SUCCESS,
  SALES_ASSISTED_APPLICATIONS_ERROR,
  SALES_ASSISTED_APPLICATIONS_FETCH,
  SALES_ASSISTED_APPLICATIONS_SUCCESS,
  SALES_ASSISTED_GET_INVITE_USER,
  SALES_ASSISTED_GET_INVITE_USER_ERROR,
  SALES_ASSISTED_GET_INVITE_USER_SUCCESS,
  SALES_ASSISTED_SEND_INVITE_USER,
  SALES_ASSISTED_SEND_INVITE_USER_ERROR,
  SALES_ASSISTED_SEND_INVITE_USER_SUCCESS,
  SALES_ASSISTED_SET_PASSWORD,
  SALES_ASSISTED_SET_PASSWORD_ERROR,
  SALES_ASSISTED_SET_PASSWORD_SUCCESS,
} from './salesAssistedActionContants';

export const authenticateSalesAssistedUser = (payload) => ({
  type: AUTHENTICATE_SALES_ASSISTED,
  payload,
});

export const autheticateSaleAssistedUserSuccess = (payload) => ({
  type: AUTHENTICATE_SALES_ASSISTED_SUCCESS,
  payload,
});

export const autheticateSaleAssistedUserError = (payload) => ({
  type: AUTHENTICATE_SALES_ASSISTED_ERROR,
  payload,
});

export const fetchSalesAssistedApplications = (payload) => ({
  type: SALES_ASSISTED_APPLICATIONS_FETCH,
  payload,
});

export const fetchSalesAssistedApplicationsSuccess = (payload) => ({
  type: SALES_ASSISTED_APPLICATIONS_SUCCESS,
  payload,
});

export const fetchSalesAssistedApplicationsError = (payload) => ({
  type: SALES_ASSISTED_APPLICATIONS_ERROR,
  payload,
});

export const salesAssistedGetInviteUser = (payload) => ({
  type: SALES_ASSISTED_GET_INVITE_USER,
  payload,
});

export const salesAssistedGetInviteUserSuccess = (payload) => ({
  type: SALES_ASSISTED_GET_INVITE_USER_SUCCESS,
  payload,
});

export const salesAssistedGetInviteUsersError = (payload) => ({
  type: SALES_ASSISTED_GET_INVITE_USER_ERROR,
  payload,
});

export const salesAssistedSendInviteUser = (payload) => ({
  type: SALES_ASSISTED_SEND_INVITE_USER,
  payload,
});

export const salesAssistedSendInviteUserSuccess = (payload) => ({
  type: SALES_ASSISTED_SEND_INVITE_USER_SUCCESS,
  payload,
});

export const salesAssistedSendInviteUsersError = (payload) => ({
  type: SALES_ASSISTED_SEND_INVITE_USER_ERROR,
  payload,
});

// reset password
export const salesAssistedSetPassword = (payload) => ({
  type: SALES_ASSISTED_SET_PASSWORD,
  payload,
});

export const salesAssistedSetPasswordSuccess = (payload) => ({
  type: SALES_ASSISTED_SET_PASSWORD_SUCCESS,
  payload,
});

export const salesAssistedSetPasswordError = (payload) => ({
  type: SALES_ASSISTED_SET_PASSWORD_ERROR,
  payload,
});
